// React
import React from "react";

import { useTranslation } from "react-i18next";
// Third party imports
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

// Styled Components
import { ToggleButton } from "./StyledComponents";

const SidebarToggleButton = ({ open, onToggle }) => {
  const { t } = useTranslation();
  return (
    <ToggleButton
      onClick={onToggle}
      aria-label={open ? t("shell:sidebar.collapse") : t("shell:sidebar.expand")}
      aria-expanded={open}
      size="small"
    >
      {open ? <FiChevronLeft /> : <FiChevronRight />}
    </ToggleButton>
  );
};

export default SidebarToggleButton;
